import React from 'react';
import { BaseModal } from './BaseModal';
import { ComingSoon } from './ComingSoon';

interface CookiesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CookiesModal({ isOpen, onClose }: CookiesModalProps) {
  const cookieImplementations = [
    {
      title: "GTM Implementation",
      description: "Cookie blocking through Google Tag Manager with OneTrust integration",
      features: [
        "Managed through GTM container",
        "Dynamic script loading based on consent",
        "Automatic cookie blocking",
        "Real-time consent updates"
      ]
    },
    {
      title: "Auto-Blocking Implementation",
      description: "Automatic script and cookie blocking using OneTrust's auto-blocking feature",
      features: [
        "No manual script modifications",
        "Automatic script detection",
        "Built-in cookie scanning",
        "Zero-configuration blocking"
      ]
    },
    {
      title: "Code Rewrite Implementation",
      description: "Manual code implementation with full control over cookie blocking",
      features: [
        "Custom implementation",
        "Fine-grained control",
        "Performance optimized",
        "Advanced use cases support"
      ]
    }
  ];

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Cookie Blocking Implementations"
    >
      <div className="space-y-6">
        <p className="text-gray-600 dark:text-gray-300">
          Explore different approaches to implementing cookie blocking:
        </p>

        <div className="grid gap-8">
          {cookieImplementations.map((implementation, index) => (
            <div 
              key={index}
              className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg hover:shadow-md transition-shadow"
            >
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                {implementation.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                {implementation.description}
              </p>
              
              <div className="mb-4">
                <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Key Features:</h4>
                <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                  {implementation.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>{feature}</li>
                  ))}
                </ul>
              </div>

              <ComingSoon 
                title="Under Construction"
                description="This example is currently being developed"
              />
            </div>
          ))}
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-600">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Each implementation approach offers different benefits and trade-offs. Choose the one that best fits your website's needs and technical requirements.
          </p>
        </div>
      </div>
    </BaseModal>
  );
}